import { useEffect, useState } from "react";

// One shared clock for every visible timer, released when the last subscriber leaves.
const listeners = new Set();
let interval;
const useNow = (enabled = true) => {
  const [now, setNow] = useState(Date.now);
  useEffect(() => {
    if (!enabled) return undefined;
    setNow(Date.now());
    listeners.add(setNow);
    if (!interval) {
      interval = setInterval(() => {
        const current = Date.now();
        listeners.forEach(listener => listener(current));
      }, 1000);
    }
    return () => {
      listeners.delete(setNow);
      if (!listeners.size) {
        clearInterval(interval);
        interval = undefined;
      }
    };
  }, [enabled]);
  return now;
};
export default useNow;
